import axios from 'axios';
axios.defaults.baseURL = "https://cfanback.agdatagh.com/v1/";
axios.defaults.headers.common['Content-Type'] = "application/json";
axios.defaults.headers.common['Accept'] = "application/json";
//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Authorization'] = "Bearer "+ localStorage.getItem("token");